var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19936_13132)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_19936_13132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16664 0H30.8333C35.8959 0 40 4.10406 40 9.16664V30.8333C40 35.8959 35.8959 40 30.8334 40H9.16664C4.10406 40 0 35.8959 0 30.8334V9.16664C0 4.10406 4.10406 0 9.16664 0Z",
    fill: "#E4E8EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9516 19.2984L15.285 11.7984C14.8982 11.5489 14.3825 11.6603 14.133 12.0471C14.0459 12.1821 13.9998 12.3394 14 12.5001V27.5001C13.9992 27.9604 14.3717 28.334 14.832 28.3348C14.9927 28.335 15.1499 28.2889 15.285 28.2018L26.9516 20.7018C27.3391 20.4535 27.452 19.938 27.2038 19.5505C27.1389 19.4493 27.0529 19.3632 26.9516 19.2984Z",
    fill: "#E64728"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19936_13132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_19936_13132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoSvg);
export default __webpack_public_path__ + "static/media/VideoSvg.4fa8d3ef4c07d788c0964b5080400986.svg";
export { ForwardRef as ReactComponent };